export default {"src":"/_next/static/media/eqli.f24599eb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};